module.exports = __webpack_public_path__ + "img/moon-4.f8afa5d8.svg";